module.exports = __webpack_public_path__ + "img/carshina22_09.10f8aa91.jpg";